import { authHeader, utils } from "../helpers/"

const apiUrl = process.env.REACT_APP_API_URL

export const categoryService = {
    getAll
}

function getAll() {
    const requestOptions = {
        method: "GET",
        headers: authHeader()
    }

    return fetch(`${apiUrl}/api/categories`, requestOptions)
        .then(utils.handleResponse)
        .then((categories) => {
            return categories.data
        })
        .catch((error) => Promise.reject(error))
}